module.exports = __webpack_public_path__ + "static/lunet-c8fa4e310f197031845ed660bd1dbd88.png";